import { useSelector } from 'react-redux';

import { DesktopAboutUs } from './Desktop';
import { MobileAboutUs } from './Mobile';
import { PANEL } from '../../../../constants/Panel';
import { useRouter } from '../../../../hooks/useRouter';
import { selectIsDesktop } from '../../../../store/settingsSlice/settingsSelectors';

export const AboutUsPage = () => {
  const isDesktop = useSelector(selectIsDesktop);
  const router = useRouter();

  const goToPredictionDesktio = () => router.forward({ panel: PANEL.PREDICTION });
  const goToPRedictionMobile = () =>  router.back();

  if (isDesktop){
    return (
      <DesktopAboutUs goToPrediction={goToPredictionDesktio}/>
    );  
  }

  return (
    <MobileAboutUs goToPrediction={goToPRedictionMobile}/>
  );
};
